import { combineReducers } from 'redux';
import userReducer from './user';
import deviceReducer from './device';
import areasReducer from './areas'

export default combineReducers({
    user: userReducer,
    device: deviceReducer,
    areas: areasReducer,
});